import { Component, Input, OnInit, Output } from '@angular/core';

import { Subject } from 'rxjs';
import {
  ViewSwitcherColor,
  ViewSwitcherOptionModel,
  ViewType
} from 'src/app/model';

@Component({
  selector: 'app-view-switcher',
  templateUrl: './view-switcher.component.html',
  styleUrls: ['./view-switcher.component.scss']
})
export class ViewSwitcherComponent implements OnInit {

  @Input() options: ViewSwitcherOptionModel[];

  @Input() showOnlyInactive: boolean = false;

  @Input() showSpacer: boolean = true;

  @Input() dynamicType: boolean = false;

  @Input() disabled: boolean = false;

  @Input()
  set activate(value: ViewSwitcherOptionModel) {
    this._setActiveState(value);
  }

  @Output() select = new Subject<ViewSwitcherOptionModel>();

  private _type: ViewType | string;
  readonly VIEW_SWITCHER_COLOR = ViewSwitcherColor;

  constructor() { }

  ngOnInit(): void { }

  /**
   * Determines whether click on
   * @param option
   */
  onClick(option: ViewSwitcherOptionModel) {
    this._setSelect(option);
  }

  /**
   * Sets select
   * @param selOption
   */
  private _setSelect(selOption: ViewSwitcherOptionModel) {
    const selType = this.dynamicType ? selOption?.dynamicType : selOption?.type;
    if (selType !== this._type) {
      this.select.next(selOption);
      this._setActiveState(selOption); 
    }
  }

  /**
   * Sets active state
   * @param selOption
   */
  private _setActiveState(selOption: ViewSwitcherOptionModel) {
    this.options = [...this.options]
      ?.map(
        (option) => {
          return {
            ...option,
            active: (
              this.dynamicType
                ? (option?.dynamicType === selOption?.dynamicType) ? true : false
                : (option?.type === selOption?.type) ? true : false
            )
          };
        }
      );
    this._type = this.dynamicType ? selOption?.dynamicType : selOption?.type;
  }
}